import { useCallback } from 'react';
import useNotification from './useNotification';
import useTranslations from './useTranslations';
import favouriteCarpiProductConfiguration from '@/actions/productWorkflow/carpi/productConfiguration/favouriteCarpiProductConfiguration';
import { useRouter } from 'next/navigation';
import useAuth from '@/lib/firebase/auth/store';
import type { DecisionDialogAnswer } from '@/types/decisionFlow';

export default function useFavourite(
  existingCarpiProductConfigurationId: string,
  answers?: Record<string, DecisionDialogAnswer>,
) {
  const notifications = useNotification();
  const { t, locale } = useTranslations();
  const router = useRouter();
  const { userId } = useAuth();

  const handleFavouriting = useCallback(async () => {
    try {
      await favouriteCarpiProductConfiguration(
        existingCarpiProductConfigurationId,
        locale,
        userId,
        answers,
      );

      router.refresh();
      notifications.success(t('product.workflow.favourite.success'));
    } catch (error) {
      console.error(error);
      notifications.error(t('product.workflow.favourite.error'));
    }
  }, [answers, existingCarpiProductConfigurationId, locale, notifications, router, t, userId]);

  return { handleFavouriting };
}
